import axios from "axios";
import React, { useEffect, useState } from "react";
import Zoom from "react-reveal/Zoom";
import { Link, Outlet } from "react-router-dom";
import Loader from "../../Dashboard/Loader";
import Menu from "../../Menu/Menu";

const Projects = ({ showAll }) => {
  const [projects, setProjects] = useState([]);
  const [page, setPage] = useState(0);
  const [selectedPage, setSelectedPage] = useState(0);
  const limit = 6;
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    let cancel = false;
    setLoader(true);
    axios
      .get(
        `https://infinite-cliffs-70499.herokuapp.com/projects?page=${selectedPage}&&showPages=${limit}`
      )
      .then((res) => {
        if (cancel) return;
        setProjects(res.data.result);
        const count = res.data.count;
        const showPage = Math.ceil(count / limit);
        setPage(showPage);
        setLoader(false);
      })
      .finally(() => setLoader(false));

    return () => {
      cancel = true;
    };
  }, [page, selectedPage]);

  //sort by name
  const sortByName = (a, b) =>
    a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
  projects.sort(sortByName);

  return (
    <section
      id="projects"
      className="container mx-auto py-20 px-3 md:px-0 min-h-screen "
    >
      {showAll && <Menu />}
      <Zoom>
        <div className="text-center">
          <h3 className="text-4xl md:text-5xl font-bold uppercase ">
            My Projects
          </h3>
        </div>

        {loader ? (
          <Loader />
        ) : (
          <div className="grid md:grid-cols-3 mt-16 gap-20 ">
            {(showAll ? projects : projects.slice(0, 3)).map((project) => (
              <div
                key={project._id}
                className="relative cursor-pointer rounded-xl  h-96 overflow-hidden"
              >
                <Link to={`/projects/${project._id}`}>
                  <img
                    className="w-full m-h-full"
                    src={`data:image/jpeg;base64,${project.img}`}
                    alt=""
                  />
                  <div className="group absolute top-0 bg-primary w-full h-full  opacity-75 z-20 hover:bg-transparent transition duration-500 flex items-center justify-center ">
                    <div className="group-hover:opacity-0 transition duration-500">
                      <h2 className="text-3xl font-bold">{project.name}</h2>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}

        {showAll ? (
          <div className="text-center mt-12">
            {[...Array(page).keys()].map((num) => (
              <button
                key={num}
                className={` px-4 py-2 border 
           ${
             selectedPage === num
               ? "bg-white text-black font-bold"
               : "text-white bg-dark "
           }
           `}
                onClick={() => setSelectedPage(num)}
              >
                {num + 1}
              </button>
            ))}
          </div>
        ) : (
          <div className="mt-14 text-center">
            <Link to="/projects">
              <h2 className=" bg-gray-200 text-blue-900 font-medium inline-block px-6 py-2 rounded hover: hover:text-white border hover:border-white transition-all cursor-pointer">
                Show more Projects
              </h2>
            </Link>
          </div>
        )}
      </Zoom>

      <Outlet />
    </section>
  );
};

export default Projects;
